import type { Severity, TriageStatus } from '@/types';
import { severityColor, statusColor, statusLabel } from '@/lib/format';

export function SeverityBadge({ severity }: { severity: Severity | null }) {
  if (!severity) return null;
  return (
    <span className="badge" style={{ background: severityColor[severity] }}>
      {severity}
    </span>
  );
}

export function StatusBadge({ status }: { status: TriageStatus }) {
  return (
    <span className="badge" style={{ background: statusColor[status] }}>
      {statusLabel[status]}
    </span>
  );
}

export function FloorBadge() {
  return <span className="badge floor-badge">🚨 dev required</span>;
}
